// extracted by mini-css-extract-plugin
module.exports = {"popover":"Popovers_popover__35kSE","label":"Popovers_label__17Acv typography_h3__2a4jt","searchPopover":"SearchPopover_searchPopover__q7dJe Popovers_popover__35kSE"};